import notesIcon from "assets/unityMenu/notes.png";
import IdleCameraOn from "assets/unityMenu/IdleCameraOn.png";
import IdleCameraOff from "assets/unityMenu/IdleCameraOff.png";
import WidgetSwitchOn from "assets/unityMenu/WidgetSwitchOn.png";
import WidgetSwitch from "assets/unityMenu/WidgetSwitch.png";
import DroneIcon from "assets/unityMenu/drone_icon.png";
import ManIcon from "assets/unityMenu/man_icon.png";
import MapIcon from "assets/unityMenu/map_icon.png";
import GridSettings from "assets/unityMenu/GridSetting.png";
import GreenGridSettings from "assets/unityMenu/GreenGridSetting.png";
import { FaMapMarkedAlt } from "react-icons/fa";
import { useUnityActions } from "hooks/unityActions";
import { FaCog } from "react-icons/fa";
import { useEffect, useState, useContext } from "react";
import { useMinifiedMenu } from "hooks/useMinifiedMenu";
import classNames from "utilities/ClassNames";
import { MdCameraAlt, MdAutorenew } from "react-icons/md";
import { BsChatDotsFill } from "react-icons/bs";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Switch } from "@mui/material";
import { ReactComponent as LinesIcon } from "assets/LinesIcon.svg";
import { Slider } from "@mui/material";

const UnityIconButton = ({ icon, onBtnClick }: { icon: React.ReactNode, onBtnClick: any }) => {
  return (
    <button className="w-10 h-10 p-1" onClick={onBtnClick}>
      {typeof icon === "string" ? (
        <img src={icon} alt="icon" className="w-full h-full" />
      ) : (
        icon
      )}
    </button>
  );
};

type UnityActionsProps = {
  sendMessageToUnity: (gameObjectName: string, methodName: string, parameter?: any) => void;
}

type UnityMenuProps = {
  sendMessageToUnity: (gameObjectName: string, methodName: string, parameter?: any) => void;
  isGridActive: boolean
  setIsGridActive: (value: boolean) => void;
};

const GridSettingsMenu = ({ sendMessageToUnity, isGridActive, setIsGridActive }: UnityMenuProps) => {
  const [switchChecked, setSwitchChecked] = useState(isGridActive);
  const [moveState, setMoveState] = useState(10);
  const [rotateState, setRotateState] = useState(30);

  useEffect(() => {
    sendMessageToUnity('ReactUIManager', 'SetGrid', JSON.stringify({
      Keyword: 'isEnabled',
      BoolValue: switchChecked
    }));
    setIsGridActive(switchChecked);
  }, [switchChecked]);

  useEffect(() => {
    sendMessageToUnity('ReactUIManager', 'SetGrid', JSON.stringify({
      Keyword: 'setMove',
      IntegerValue: moveState
    }));
  }, [moveState]);

  useEffect(() => {
    sendMessageToUnity('ReactUIManager', 'SetGrid', JSON.stringify({
      Keyword: 'setRotate',
      IntegerValue: rotateState
    }));
  }, [rotateState]);

  const handleMoveChange = (_event: Event, newValue: number | number[]) => {
    const updatedValue = Array.isArray(newValue) ? newValue[0] : newValue;
    setMoveState(updatedValue);
  };

  const handleRotateChange = (_event: Event, newValue: number | number[]) => {
    const updatedValue = Array.isArray(newValue) ? newValue[0] : newValue;
    setRotateState(updatedValue);
  };

  return (
    <div>
      <h3 className="text-center">Grid Settings</h3>
      <div className="flex gap-2 items-center justify-between">
        <p>Enable:</p>
        <Switch
          checked={switchChecked}
          onChange={() => setSwitchChecked((prev) => !prev)}
          inputProps={{ "aria-label": "controlled" }}
          sx={{
            "& .MuiSwitch-track": {
              backgroundColor: "gray",
            },
          }}
        />
      </div>
      <div className="flex gap-2 items-center">
        <span className="min-w-[75px] flex items-center justify-start">Move:</span>
        <div className="w-full flex justify-center items-center relative gap-4">
          <Slider
            value={moveState}
            onChange={handleMoveChange}
            aria-label="Steps"
            valueLabelDisplay="off"
            min={0}
            max={100}
            step={1}
            sx={{
              "& .MuiSlider-track": {
                bgcolor: "white",
                height: '8px',
              },
              "& .MuiSlider-rail": {
                bgcolor: "#65F4CD",
                height: '8px'
              },
              "& .MuiSlider-thumb": {
                bgcolor: "white",
                border: "3px solid #65F4CD",
                height: '18px',
                width: '18px',
                marginLeft: '4px',
              },
            }}
            className="pr-2"
          />
          <div className="w-10">
            {moveState}
          </div>
        </div>
      </div>
      <div className="flex gap-2 items-center">
        <span className="min-w-[75px] flex items-center justify-start">Rotate:</span>
        <div className="w-full flex justify-center items-center relative gap-4">
          <Slider
            value={rotateState}
            onChange={handleRotateChange}
            aria-label="Steps"
            valueLabelDisplay="off"
            min={0}
            max={180}
            step={1}
            sx={{
              "& .MuiSlider-track": {
                bgcolor: "white",
                height: '8px',
              },
              "& .MuiSlider-rail": {
                bgcolor: "#65F4CD",
                height: '8px'
              },
              "& .MuiSlider-thumb": {
                bgcolor: "white",
                border: "3px solid #65F4CD",
                height: '18px',
                width: '18px',
                marginLeft: '4px',
              },
            }}
            className="pr-2"
          />
          <div className="w-10">
            {rotateState}
          </div>
        </div>
      </div>
    </div>
  );
};

const UnityActionsWindow = ({ sendMessageToUnity }: UnityActionsProps) => {

  const {
    addItemToPosition,
    removeMinifiedTab
  } = useMinifiedMenu();

  const [isLineCreationShown, setIsLineCreationShown] = useState(true);

  useEffect(() => {
    sendMessageToUnity('ReactUIManager', 'SetToggle', JSON.stringify({
      Keyword: 'SetLinesActivity',
      BoolValue: isLineCreationShown
    }));
  }, [isLineCreationShown]);

  const {
    editingMode, setEditingMode,
    idleCameraMode, setIdleCameraMode,
    widgetSwitch, setWidgetSwitch,
    viewMode, setViewMode,
  } = useUnityActions();
  const [resetActive, setResetActive] = useState(false);
  const [onlineChat, setOnlineChat] = useState(false);
  const [infoShown, setInfoShown] = useState(false);
  const [isGridMenuShown, setIsGridMenuShown] = useState(false);
  const [isGridActive, setIsGridActive] = useState(false);
  const [isMinimapShown, setIsMinimapShown] = useState(false);

  useEffect(() => {
    if (resetActive) {
      sendMessageToUnity('ReactUIManager', 'ResetCamera');
      setResetActive(false);
    }
  }, [resetActive]);

  useEffect(() => {
    sendMessageToUnity('ReactUIManager', 'SetToggle', JSON.stringify({
      Keyword: 'EditingMode',
      BoolValue: editingMode
    }));
  }, [editingMode]);

  useEffect(() => {
    sendMessageToUnity('ReactUIManager', 'SetToggle', JSON.stringify({
      Keyword: 'mini-map',
      BoolValue: isMinimapShown
    }));
  }, [isMinimapShown]);

  useEffect(() => {
    sendMessageToUnity('ReactUIManager', 'SetToggle', JSON.stringify({
      Keyword: 'FlyByMode',
      BoolValue: idleCameraMode
    }));
  }, [idleCameraMode]);

  useEffect(() => {
    sendMessageToUnity('ReactUIManager', 'SetToggle', JSON.stringify({
      Keyword: 'ShowWidgets',
      BoolValue: widgetSwitch
    }));
  }, [widgetSwitch]);

  useEffect(() => {
    if (viewMode !== 3) {
      setEditingMode(false);
    }
    sendMessageToUnity('ReactUIManager', 'SetToggleGroup', JSON.stringify({
      Keyword: 'CameraMode',
      IntegerValue: viewMode
    }));
  }, [viewMode]);

  useEffect(() => {
    sendMessageToUnity('ReactUIManager', 'SetToggle', JSON.stringify({
      Keyword: 'ShowChat',
      BoolValue: onlineChat
    }));
  }, [onlineChat]);

  useEffect(() => {
    sendMessageToUnity('ReactUIManager', 'SetToggle', JSON.stringify({
      Keyword: 'ShowInfo',
      BoolValue: infoShown
    }));
  }, [infoShown]);

  const handleViewModeClick = () => {
    if (viewMode === 3) {
      setViewMode(1);
    } else {
      setViewMode((prev) => prev + 1);
    }
  };

  const cameraModeIcons = [
    ManIcon,
    DroneIcon,
    MapIcon
  ];

  return (
    <div>
      <div className="bg-dark/70 rounded-md flex gap-2 pr-1 relative">
        <UnityIconButton icon={notesIcon} onBtnClick={() => sendMessageToUnity('ReactUIManager', 'SetButton', JSON.stringify({ Keyword: 'AddNote' }))} />
        <UnityIconButton icon={<FaCog size={24} className={editingMode ? "text-green" : "text-white"} />} onBtnClick={() => setEditingMode((prev) => !prev)} />
        <UnityIconButton icon={idleCameraMode ? IdleCameraOff : IdleCameraOn} onBtnClick={() => setIdleCameraMode((prev) => !prev)} />
        <UnityIconButton icon={widgetSwitch ? WidgetSwitchOn : WidgetSwitch} onBtnClick={() => setWidgetSwitch((prev) => !prev)} />
        <UnityIconButton icon={<BsChatDotsFill size={24} className={onlineChat ? "text-green" : "text-white"} />} onBtnClick={() => setOnlineChat((prev) => !prev)} />
        <UnityIconButton icon={isGridActive ? GreenGridSettings : GridSettings} onBtnClick={() => setIsGridMenuShown((prev) => !prev)} />
        <UnityIconButton icon={cameraModeIcons[viewMode - 1]} onBtnClick={handleViewModeClick} />
        <UnityIconButton icon={<AiOutlineInfoCircle size={24} className={infoShown ? "text-green" : "text-white"} />} onBtnClick={() => setInfoShown((prev) => !prev)} />
        <button className="relative w-10 h-10" onClick={() => setResetActive(true)}>
          <MdAutorenew
            className={classNames(
              "absolute inset-0 m-auto text-gray-400 transition-transform duration-1000 ease-out",
              resetActive ? "rotate-[360deg]" : "rotate-0"
            )}
            size={38}
          />
          <MdCameraAlt className="absolute inset-0 m-auto text-white" size={16} />
        </button>
        <UnityIconButton icon={<FaMapMarkedAlt size={24} className={isMinimapShown ? "text-green" : "text-white"} />} onBtnClick={() => setIsMinimapShown((prev) => !prev)} />
        <UnityIconButton icon={<LinesIcon className={classNames(isLineCreationShown ? "text-green" : "text-white", "w-6 h-6")} />} onBtnClick={() => setIsLineCreationShown((prev) => !prev)} />
      </div>
      {isGridMenuShown && <div className="w-full h-max rounded-lg mt-2">
        <div className="bg-dark/70 w-[47%] rounded-lg p-2 ml-auto">
          <GridSettingsMenu sendMessageToUnity={sendMessageToUnity} isGridActive={isGridActive} setIsGridActive={setIsGridActive} />
        </div>
      </div>}
    </div>
  );
};

export default UnityActionsWindow;